import { EdgeProps } from "reactflow";
import BaseEdge from "./base/BaseEdge";

export const StartEdge = (edgeProps: EdgeProps) => {
  return <BaseEdge {...edgeProps} color={"red.800"} isDashed={true} />;
};
